export const APP_CARS_HOME_PATH = "/acko-app/cars/";

export const APP_SELECT_CITY_PATH = "/acko-app/select-city/";

/** Query on select-city full URL so after pick we can `router.replace` back to the caller. */
export const APP_SELECT_CITY_RETURN_URL_QUERY = "returnUrl";

